<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
                        danh sách đánh giá</span></h3>
            </div>
            <div class="card-body">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Người đánh giá:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input clearable placeholder="Người đánh giá..."
                                    v-model="search.cHoTenNguoiDanhGia" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Số điện thoại:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input clearable placeholder="Số điện thoại..." v-model="search.cSoDienThoai" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Từ:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-date-picker v-model="search.tuNgay" placeholder="Chọn ngày"
                                    type="date" class="w-100" format="DD/MM/YYYY" value-format="DD/MM/YYYY">
                                </el-date-picker>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Đến:</label>
                        <div class="d-flex">
                            <el-date-picker v-model="search.denNgay" placeholder="Chọn ngày"
                                type="date" class="w-100" format="DD/MM/YYYY" value-format="DD/MM/YYYY">
                            </el-date-picker>
                            <el-button plain type="primary" title="Tìm kiếm"
                                @click="this.handleFindPage()" class="ms-2"><i
                                    class="fa fa-search"></i></el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="card data-table mb-5 mb-xl-10">
            <div class="card-header py-3">
                <!-- <div class="body-function">
                    <div class="col-md-6">
                        <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd"
                            data-bs-toggle="modal" data-bs-target="#modal_hotline">
                            <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
                            <span class="btn-inner--text">&nbsp;Thêm đánh giá </span>
                        </el-button>
                    </div>
                </div> -->
            </div>
            <div class="card-body">
                <div class="col-md-12 tbl">
                    <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%"
                        height="100%" fit stripe highlight-current-row>
                        <el-table-column prop="nMaDanhGia" label="Mã" width="100" align="center"></el-table-column>
                        <el-table-column prop="cHoTenNguoiDanhGia" label="Người đánh giá" width="180"
                            header-align="center"></el-table-column>
                        <el-table-column prop="cSoDienThoai" label="Số điện thoại" width="120"  align="center"
                            header-align="center"></el-table-column>
                        <el-table-column prop="nDanhGia" label="Đánh giá" width="100" align="center"
                            header-align="center">
                            <template #default="scope">
                                {{ scope.row.nDanhGia + " / 5" }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="cNoiDung" label="Nội dung" min-width="150"
                            header-align="center"></el-table-column>
                        <el-table-column prop="dNgayTao" label="Ngày tạo" width="120">
                            <template #default="scope">
                                {{ momentDate(scope.row.dNgayTao) }}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="" label="Trạng thái" width="120" align="center">
                            <template #default="scope">
                                <el-tag type="success" v-if="scope.row.nTinhTrang == 1" size="small">Hoạt Động</el-tag>
                                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" size="small">Đã xóa</el-tag>
                            </template>
                        </el-table-column> -->
                        <!-- Button hành động -->
                        <el-table-column width="150" label="Hành động" align="center">
                            <template #default="scope">
                                <el-button plain type="primary" @click="handleOpenInfo(scope.row)"
                                    data-bs-toggle="modal" data-bs-target="#modal_hotline">
                                    <span class="btn-inner--icon"><i class="fas fa-info"></i></span>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="col-12 py-2 pagination" style="justify-content: end">
                <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
                    :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="tableData.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableData.totalSize">
                </el-pagination>
            </div>
        </div>

        <div class="modal fade" id="modal_hotline" ref="hotlineModalRef" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered mw-650px">
                <div class="modal-content">
                    <!--begin::Modal header-->
                    <div class="modal-header" id="modal_hotline_header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bolder">{{ "Thông tin chi tiết đánh giá" }}</h2>
                        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
                            @click="handleClose">
                            <span class="svg-icon svg-icon-1">
                                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                            </span>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Modal header-->
                    <div class="modal-body">
                        <el-form :model="formData" :rules="rules" ref="formData" label-width="150px"
                            class=" d-flex flex-column">
                            <el-form-item label="Họ tên:" prop="cHoTenNguoiDanhGia">
                                {{ formData.cHoTenNguoiDanhGia }}
                            </el-form-item>
                            <el-form-item label="Số điện thoại:" prop="cHoTenNguoiDanhGia">
                                {{ formData.cSoDienThoai }}
                            </el-form-item>
                            <el-form-item label="Đánh giá:" prop="cHoTenNguoiDanhGia">
                                {{ formData.nDanhGia + " / 5" }}
                            </el-form-item>
                            <el-form-item label="Nội dung:" prop="cHoTenNguoiDanhGia">
                                {{ formData.cNoiDung }}
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-group">
                            <el-button plain type="danger" @click="handleClose">Thoát</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Rating } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { ElMessage } from "element-plus";
export default {
    name: 'rating',
    data() {
        return {
            search: {
                cHoTenNguoiDanhGia: "",
                cSoDienThoai: "",
                tuNgay: moment(Date.now()).format("01/MM/YYYY") ,
                denNgay: moment(Date.now()).format("DD/MM/YYYY") ,
            },
            pageRequest: {
                columnFilters: {},
                pageSize: 30,
                pageNum: 1
            },
            formData: {},
            tableData: {
                content: [{}]
            },
            isLoading: false,
            modalVisible: false,
            operation: false,
            iframeURL: "",
            openIframe: false,
            isSearchLoading: false,
            store: useStore(),
        }
    },
    methods: {
        handleChangePageNum(val) {
            this.pageRequest.pageNum = val
            this.handleFindPage()
        },
        handleChangePageSize(val) {
            this.pageRequest.pageSize = val
            this.handleFindPage()
        },
        handleOpenInfo(val) {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = true
            this.formData = Object.assign({}, val)
        },
        handleClose() {
            this.$refs.formData.resetFields()
            this.modalVisible = false
            hideModal(this.$refs.hotlineModalRef)
        },
        handleFindPage() {
            this.pageRequest.columnFilters = {
                cHoTenNguoiDanhGia: { value: this.search.cHoTenNguoiDanhGia },
                cSoDienThoai: { value: this.search.cSoDienThoai },
                tuNgay: { value: this.search.tuNgay },
                denNgay: { value: this.search.denNgay },
            }
            this.store.dispatch(Rating.findPageRating, this.pageRequest).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data
                }
            }).catch((error) => {
                ElMessage({ message: "Tìm đánh giá thất bại", type: "error" });
            })
        },
        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY") : ""
        }
    },
    mounted() {
        this.handleFindPage()
    }
};
</script>
<style lang="scss"></style>